module.exports = __webpack_public_path__ + "static/media/45.8bfb1a7c.jpg";